import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { pluck, map, mergeMap } from 'rxjs/operators';

import { DeliveryListService } from 'app/shared/components/delivery-list/delivery-list.service';
import * as fromActions from '../actions/filter.actions';

@Injectable()
export class FilterEffects {
  actions$ = inject(Actions);
  deliveryListService = inject(DeliveryListService);

  setFilterViewType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.setViewType),
      pluck('payload'),
      map((displayView) => {
        this.deliveryListService.setViewType(displayView);
        return fromActions.setViewTypeSuccess({ payload: displayView });
      }),
    ),
  );

  setStorageDisplayView$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.setStorageDisplayView),
      mergeMap(() =>
        this.deliveryListService
          .getViewType()
          .pipe(map((displayView) => fromActions.setViewTypeSuccess({ payload: displayView }))),
      ),
    ),
  );
}
